import React from 'react'
import card1 from '../assets/project section grid.png';
import quack from "../assets/quack.png";
import elderly from "../assets/elderly.png";
import lost from "../assets/lost-and-found-cover.png";
import paqui from "../assets/paqui.png";
import parkd from "../assets/parkd.png";
import trail from "../assets/trail.png";
import nexis from "../assets/nexis.png";

const Projects = () => {
  return (
    <div className='projects' id='projects'>
      
      <div className='sec1-about'>
        <p className='head-about'>You are now entering my 'Projects' section</p>
        <p className='tag-about'>3</p>
      </div>

      <div className='cards-sec-projects'>
        <a className='card1'>
          <img src={card1} />
        </a>

        <a href='https://www.behance.net/gallery/199569939/Healthcare-Service-Design-Quack' target='_blank' className='card2'>
          <img src={quack} />

          <div className='card2-text'>
            <p className='p1-card'>Service Design <b className=' text-black'>|</b> <br/> Experience Design <b className=' text-black'>|</b> <br/>
            Healthcare  <b className=' text-black'>|</b> <br/> Interface Design <b className=' text-black'>|</b></p>
            <div>
              <p className='p2-card'>Quack</p>
              <p className='p3-card'>A service design concept that bridges the gap between fragmented healthcare systems.</p>
            </div>
          </div>
        </a>

        <a href='https://www.behance.net/gallery/209398501/NEXIS-an-IoT-system-to-justify-design-decisions' target='_blank' className='card-project'>
          <img src={nexis} />

          <div className='card2-textproject'>
            <p className='p1-cardproject'>UX Case Study <b className=' text-black'>|</b> Dashboard Design <b className=' text-black'>|</b> <br/> Web UI design <b className=' text-black'>|</b> Visual Design Concept <b className=' text-black'>|</b></p>
            <div>
              <p className='p2-cardproject'>IoT System For Designers</p>
              <p className='p3-cardproject'>An IoT concept that uses real time data and metrics to support a designers design decisions</p>
            </div>
          </div>
        </a>

        <a href='https://www.behance.net/gallery/185987093/Design-System-for-the-elderly(UX-case-study)' target='_blank' className='card-project'>
          <img src={elderly} />

          <div className='card2-textproject'>
            <p className='p1-cardproject'>UX Case Study <b className=' text-black'>|</b> Experience Design <b className=' text-black'>|</b> <br/> Elderly design <b className=' text-black'>|</b> Interface Design Concept <b className=' text-black'>|</b></p>
            <div>
              <p className='p2-cardproject'>Elderly focused Design System</p>
              <p className='p3-cardproject'>An UX research study to optimize elderly individuals experience while using mobile applications.</p>
            </div>
          </div>
        </a>

        <a href='https://www.behance.net/gallery/195184679/Lost-and-Found-UXUX-design-concept-Gamification' target='_blank' className='card-project'>
          <img src={lost} />

          <div className='card2-textproject'>
            <p className='p1-cardproject'>UX Case Study <b className=' text-black'>|</b> Experience Design <b className=' text-black'>|</b> <br/> Elderly design <b className=' text-black'>|</b> Interface Design Concept <b className=' text-black'>|</b></p>
            <div>
              <p className='p2-cardproject'>Lost-and-Found Gamified App</p>
              <p className='p3-cardproject'>An UI/UX project that explores gamification that turns lost and found items into a unique treasure hunting experience. </p>
            </div>
          </div>
        </a>

        <a href='https://www.behance.net/gallery/173123567/PAQUI-Indian-Flavours-Packaging-Concept' target='_blank' className='card-project'>
          <img src={paqui} />

          <div className='card2-textproject'>
            <p className='p1-cardproject'>UX Case Study <b className=' text-black'>|</b> Experience Design <b className=' text-black'>|</b> <br/> Elderly design <b className=' text-black'>|</b> Interface Design Concept <b className=' text-black'>|</b></p>
            <div>
              <p className='p2-cardproject'>Paqui, Indian Flavour Designs</p>
              <p className='p3-cardproject'>Introducing Indian flavours with unique design concepts to the American chip brand ‘Paqui’.</p>
            </div>
          </div>
        </a>

        <a href='https://www.behance.net/gallery/202774597/PARKD-app-for-finding-parking-spots' target='_blank' className='card-project'>
          <img src={parkd} />

          <div className='card2-textproject'>
            <p className='p1-cardproject'>UX Case Study <b className=' text-black'>|</b> Experience Design <b className=' text-black'>|</b> <br/> Elderly design <b className=' text-black'>|</b> Interface Design Concept <b className=' text-black'>|</b></p>
            <div>
              <p className='p2-cardproject'>Intuitive Parking Finder</p>
              <p className='p3-cardproject'>A Parking app concept that allows users to easily locate nearest parking spots.</p>
            </div>
          </div>
        </a>

        <a href='https://www.behance.net/gallery/165597909/TRAIL-sustainable-travel-UIUX-concept' target='_blank' className='card-project'>
          <img src={trail} />

          <div className='card2-textproject'>
            <p className='p1-cardproject'>UX Case Study <b className=' text-black'>|</b> Experience Design <b className=' text-black'>|</b> <br/> Elderly design <b className=' text-black'>|</b> Interface Design Concept <b className=' text-black'>|</b></p>
            <div>
              <p className='p2-cardproject'>Sustainable Travel App</p>
              <p className='p3-cardproject'>A travel app that promotes ‘Revenge travel’ in India while reducing users carbon footprint using AI.</p>
            </div>
          </div>
        </a>
        
      </div>

    </div>
  )
}

export default Projects;